// components/RequirePermission.jsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { hasPagePermission, isAllowedByDesignedMenu, isOwnerRouteAllowed } from '../utils/accessControl';

export default function RequirePermission({ page, anyOf = [], children }) {
  const location = useLocation();

  // المطلوب: إذا ما تم تمرير page/anyOf استخدم المسار الحالي
  const rawRequired =
    (Array.isArray(page) ? page : [page]).filter(Boolean).length === 0 &&
    (anyOf || []).length === 0
      ? [location.pathname]
      : [...(Array.isArray(page) ? page : [page]), ...(anyOf || [])].filter(
          Boolean
        );

  let perms = [];
  try {
    perms = JSON.parse(localStorage.getItem('permissions') || '[]');
  } catch {
    perms = [];
  }

  const allowed =
    isOwnerRouteAllowed(location.pathname) ||
    (hasPagePermission(perms, rawRequired, location.pathname) && isAllowedByDesignedMenu(location.pathname));

  return allowed ? (
    children
  ) : (
    <Navigate to="/No-access" replace state={{ from: location.pathname }} />
  );
}
